class InfraUtil {
  static rootURL() {
    return window.location.origin + process.env.PUBLIC_URL + '/'
  }
}

export default InfraUtil


// WEBPACK FOOTER //
// ./src/Infra/InfraUtil.js